// First-touch (90 days, never overwritten) + last-touch attribution cookies, shared across *.screenzz.com.
const FT = "sz_ft";
const LT = "sz_lt";
const MAX_AGE = 90 * 86400;
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid", "gbraid", "wbraid"];

const cookieDomain = () => (window.location.hostname.endsWith("screenzz.com") ? "; domain=.screenzz.com" : "");
const isInternal = (host) => host === window.location.hostname || host === "screenzz.com" || host.endsWith(".screenzz.com");

const read = (name) => {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    const raw = m ? decodeURIComponent(m[1]) : localStorage.getItem(name);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};
const write = (name, value) => {
  const raw = JSON.stringify(value);
  try { document.cookie = `${name}=${encodeURIComponent(raw)}; max-age=${MAX_AGE}; path=/; SameSite=Lax${cookieDomain()}`; } catch { /* ignore */ }
  try { localStorage.setItem(name, raw); } catch { /* ignore */ }
};

const currentTouch = () => {
  const q = new URLSearchParams(window.location.search);
  const t = {};
  PARAMS.forEach((k) => { const v = q.get(k); if (v) t[k] = v.slice(0, 200); });
  let refHost = "";
  try { refHost = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ""; } catch { /* ignore */ }
  if (document.referrer) t.referrer = document.referrer.slice(0, 300);
  t.landing_page = window.location.href.slice(0, 300);
  t.ts = new Date().toISOString();
  return { touch: t, hasParams: PARAMS.some((k) => t[k]), externalRef: !!refHost && !isInternal(refHost) };
};

const fromParam = (v) => {
  try { const o = v ? JSON.parse(v) : null; return o && typeof o === "object" && !Array.isArray(o) ? o : null; } catch { return null; }
};

// Runs on every app load: first page view of a visit, or any later load that carries new campaign params.
export function captureAttribution() {
  // Link backup from the main website script: ?sz_ft=<json>&sz_lt=<json> carry the original touches.
  const q = new URLSearchParams(window.location.search);
  const passedFt = fromParam(q.get("sz_ft"));
  const passedLt = fromParam(q.get("sz_lt"));
  if (passedFt && !read(FT)) write(FT, passedFt);
  if (passedLt) {
    write(LT, passedLt);
    if (!read(FT)) write(FT, passedLt);
    try { sessionStorage.setItem("sz_visit_captured", "1"); } catch { /* ignore */ }
    return;
  }
  const { touch, hasParams, externalRef } = currentTouch();
  let firstView = true;
  try {
    firstView = !sessionStorage.getItem("sz_visit_captured");
    sessionStorage.setItem("sz_visit_captured", "1");
  } catch { /* ignore */ }
  if (!firstView && !hasParams) return;
  const meaningful = hasParams || externalRef;
  if (!read(FT)) write(FT, touch);
  // Internal hops (main site -> quote page) with no params keep the touch the main site already set.
  if (meaningful || !read(LT)) write(LT, touch);
}

export const getAttribution = () => ({ first_touch: read(FT), last_touch: read(LT) });
